import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AntiAuthGuard } from './general/guards/anti-auth.guard';
import { AuthGuard } from './general/guards/auth.guard';
import { TenantFoundGuard } from './general/guards/tenant-found.guard';
import { provideSettingsElementGeneralSettings } from './general/settings/general-settings/general-settings.provider';
import { provideSettingsElementAuditLogSettings } from './general/settings/audit-log/audit-log.provider';
import { provideSettingsElementAccess } from './general/settings/access/access.provider';
import { provideSettingsElementSmsGateway } from './general/settings/sms-gateway/sms-gateway.provider';

const routes: Routes = [
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  {
    path: 'fnrl',
    loadChildren: () =>
      import('./business-domains/funeral/funeral.module').then((m) => m.FuneralModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'rsa',
    loadChildren: () => import('./business-domains/rsa/rsa.module').then((m) => m.RsaModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'login',
    loadChildren: () =>
      import('./general/authentication/login/login.module').then((m) => m.LoginModule),
    canActivate: [AntiAuthGuard],
  },
  {
    path: 'tenant-not-found',
    loadChildren: () =>
      import('./general/authentication/tenant-not-found/tenant-not-found.module').then(
        (m) => m.TenantNotFoundModule
      ),
    canActivate: [TenantFoundGuard],
  },
  {
    path: 'reset-password',
    loadChildren: () =>
      import('./general/authentication/reset-password/reset-password.module').then(
        (m) => m.ResetPasswordModule
      ),
    canActivate: [AntiAuthGuard],
  },
  {
    path: 'change-password',
    loadChildren: () =>
      import('./general/authentication/change-password/change-password.module').then(
        (m) => m.ChangePasswordModule
      ),
    canActivate: [AntiAuthGuard],
  },
  // {
  //   path: 'settings',
  //   loadChildren: () => import('./general/settings/settings.routes').then((m) => m.APP_ROUTES),
  //   canActivate: [AuthGuard],
  //   providers: [
  //     provideSettingsElementGeneralSettings(),
  //     provideSettingsElementAuditLogSettings(),
  //     provideSettingsElementAccess(),
  //     provideSettingsElementSmsGateway(),
  //   ],
  // },
  { path: '**', redirectTo: '/login' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
